export const ModalResetPasswordTranslationsCs = {
  resetPassword: 'Zapomenuté heslo',
  Email: 'Email',
  saveButton: 'Uložit',
  enterYourEmail: 'Zadejte svůj Email',
};
